<template>
    <div class="pa-5 compact-form" v-if="activeUser">
        <div v-for="(item, index) in activeUser.custom_links" :key="item.title + '_' + index">
            <v-row no-gutters>
                <v-col class="mt-3 row-title" cols="3">{{ "Title" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.title"
                        @input="updateCustomLinksField($event, 'title', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Active" | t }}</v-col>
                <v-col cols="6">
                    <v-checkbox
                        :value="item.is_active"
                        v-model="item.is_active"
                        @input="updateCustomLinksField($event, 'is_active', index)"
                        class="text-field-item mb-2 mt-2 pt-0"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Open in" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :value="item.open_in"
                        @input="updateCustomLinksField($event, 'open_in', index)"
                        class="mb-1"
                        :items="openInItems"
                        placeholder="Select"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "URL" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.url"
                        @input="updateCustomLinksField($event, 'url', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>

            <v-row no-gutters justify="end" class="mr-2">
                <v-btn dark color="bal-red" class="px-2" @click.stop="deleteLink(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn dark color="bal-red" class="px-2 ml-2" @click.stop="addNewLink" style="min-width: 0;">
            <v-icon>add</v-icon><span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "custom-links-edit-tab",
    data() {
        return { openInItems: ["iframe", "new tab"] };
    },
    computed: {
        ...mapState("UserStore", ["activeUser"])
    },
    methods: {
        updateCustomLinksField(value, field, index) {
            Store.commit("UserStore/updateActiveUserCustomLinksProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        addNewLink() {
            Store.commit("UserStore/addNewLink");
        },
        deleteLink(index) {
            if (confirm("Are you sure you want to delete this Link?")) {
                Store.commit("UserStore/deleteLink", index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
